import RecoveryAgent from "@/models/recoveryAgent.model";
import Vue from "vue";
import { MutationTree } from "vuex";
import { State } from "./state";

export enum MutationTypes {
  SetAgents = "SET_AGENTS",
  RemoveAgent = "REMOVE_AGENT",
  AddAgent = "ADD_AGENT"
}

export const mutations: MutationTree<State> = {
  [MutationTypes.SetAgents](state, agents?: RecoveryAgent[]) {
    Vue.set(state, "agents", agents ?? []);
  },
  [MutationTypes.RemoveAgent](state, agentEmail: string) {
    const idx = state.agents.findIndex((x) => x.email === agentEmail);
    if (idx >= 0) {
      state.agents.splice(idx, 1);
    }
  },
  [MutationTypes.AddAgent](state, agent: any) {
    state.agents.push(new RecoveryAgent(agent));
  }
};
